<script setup>
// import { useRouter } from 'vue-router'
import { useWebSiteStore } from '@/stores/website.store'
import { useLocalizationStore } from '@/stores/localizations.store'
import { onMounted } from 'vue'
import { useQuasar } from 'quasar'
import i18n from '@/plugins/i18n'

import UserSettingsCard from '@/components/user/UserSettingsCard.vue'
import UserDashboard from '@/components/user/UserDashboard.vue'
import { useNotify } from '@/composables/notify'

// --- 1. Init & Composables ---

const { notifySuccess, notifyError } = useNotify()
// const router = useRouter()
const websiteStore = useWebSiteStore()
const localizationStore = useLocalizationStore()

const t = i18n.global.t
const $q = useQuasar()
// const goToSubscriptions = () => {
//   router.push({ name: 'subscriptions-manage' })
// }

// --- 2. State & Computed ---

// --- 3. API Actions ---
const fetchUserDataAsync = async() => {
  await websiteStore.fetchUserData()
}

const onSave = (params) => {
  params = {
    ...params,
    default_language: localizationStore.selectedLanguage,
  }
  websiteStore.updateUserData(params)
  notifySuccess(t('user.notifications.settingsSaved'))
}

const onDeleteAccount = async() => {
  try {
    await websiteStore.deleteAccountAsync()
    await websiteStore.logoutAsync()

    $q.dialog({
      title: t('user.requestReceived'),
      message: t('user.emailConfirmationAlert'),
      persistent: true,
      ok: {
        label: t('common.close'),
        color: 'primary',
        unelevated: true
      }
    }).onOk(async() => {
      websiteStore.logoutAsync()
    })
  } catch (error) {
    notifyError(t('user.notifications.deleteError'))
  }
}
// --- 4. Dialogs / Handlers ---
const confirmDeleteAccount = () => {
  $q.dialog({
    title: t('user.deleteAccount'),
    message: `
      <p>${t('user.deleteAccountAlert1')}</p>
      <p><strong>${t('user.deleteAccountAlert2')}</strong></p>
      <p>${t('user.deleteAccountAlert3')}</p>
      <p>${t('common.proceedQuestion')}</p>
    `,
    html: true,
    cancel: {
      label: t('common.cancel'),
      color: 'grey-7',
      flat: true
    },
    ok: {
      label: t('common.confirm'),
      color: 'negative',
      unelevated: true
    },
    persistent: true
  }).onOk(() => {
    onDeleteAccount()
  })
}

// --- 5. Lifecycle ---
onMounted(() => {
  fetchUserDataAsync()
})
</script>

<template>
  <q-page
    class="q-pa-md"
  >
    <div class="q-mb-md">
      <div class="text-h5 text-weight-bold">
        {{ $t('user.title') }}
      </div>
      <div class="text-subtitle2 text-grey-7">
        {{ $t('user.subtitle') }}
      </div>
    </div>
    <!-- <user-settings-card /> -->
    <user-dashboard
      :user-data="websiteStore.userData"
    />

    <user-settings-card
      class="q-mt-md"
      :user-data="websiteStore.userData"
      @save="onSave"
    />

    <!-- Delete account  -->
    <q-card class="q-mt-md">
      <q-card-section class="q-pa-md">
        <div>
          <div class="text-h6">
            {{ $t('user.deleteAccount') }}
          </div>
          <div class="text-caption text-grey-7">
            {{ $t('user.deleteAccountDescription') }}
          </div>
          <div class="row justify-end q-mt-md">
            <q-btn
              outline
              color="negative"
              @click="confirmDeleteAccount"
            >
              {{ $t('common.delete') }}
            </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- <div class="q-mt-md">
      <q-btn
        color="secondary"
        class="full-width"
        :label="$t('subscriptions.goToSubscriptions')"
        @click="goToSubscriptions"
      />
    </div> -->
  </q-page>
</template>

